import React from 'react';
import styled from 'styled-components';
import { Quill } from 'react-quill-new';
import { ImageResize } from 'quill-image-resize-module-ts';
import theme from '@styles/theme';

const fontSizeArray = [
    '12px',
    '14px',
    '15px',
    '16px',
    '18px',
    '20px',
    '22px',
    '24px',
    '26px',
    '28px',
    '30px',
    '32px'
];
const Font = Quill.import('attributors/class/font') as any;
const Size = Quill.import('formats/size') as any;
Size.whitelist = fontSizeArray;
Font.whitelist = [
    'pretendard',
    'AppleSDGothicNeo',
    'sans-serif',
    'NanumGothic',
    'monospace'
];
Quill.register(Font, true);
Quill.register(Size, true);
Quill.register('modules/imageResize', ImageResize);

const CustomToolBar = () => {
    return (
        <ToolBar id="text-editor-toolbar">
            <span className="ql-formats">
                <select className="ql-header" defaultValue="0">
                    <option value="0" disabled>
                        선택
                    </option>
                    <option value="1">Header 1</option>
                    <option value="2">Header 2</option>
                    <option value="3">Header 3</option>
                    <option value="4">Header 4</option>
                    <option value="5">Header 5</option>
                    <option value="6">Header 6</option>
                </select>
                <select className="ql-font" defaultValue="0">
                    <option value="pretendard">Pretendard</option>
                    <option value="AppleSDGothicNeo">AppleSDGothicNeo</option>
                    <option value="sans-serif">Sans Serif</option>
                    <option value="NanumGothic">나눔고딕</option>
                    <option value="monospace">Monospace</option>
                </select>
                <select className="ql-size" defaultValue="16px">
                    {fontSizeArray.map((size) => (
                        <option key={`${size}-fontSize`} value={size}>
                            {size}
                        </option>
                    ))}
                </select>
            </span>
            <span className="ql-formats">
                <button className="ql-bold" />
                <button className="ql-italic" />
                <button className="ql-underline" />
                <button className="ql-strike" />
            </span>
            <span className="ql-formats">
                <button className="ql-list" value="ordered" />
                <button className="ql-list" value="bullet" />
                <button className="ql-indent" value="-1" />
                <button className="ql-indent" value="+1" />
            </span>
            <span className="ql-formats">
                <button className="ql-blockquote" />
            </span>
            <span className="ql-formats">
                <select className="ql-align" />
                <select className="ql-color" />
                <select className="ql-background" />
            </span>
            <span className="ql-formats">
                <button className="ql-link" />
                <button className="ql-image" />
            </span>
            <span className="ql-formats">
                <button className="ql-formula" />
                <button className="ql-code-block" />
                <button className="ql-clean" />
            </span>

            <span className="ql-formats">
                <button className="ql-undo">
                    <svg viewBox="0 0 18 18">
                        <polygon
                            className="ql-fill ql-stroke"
                            points="6 10 4 12 2 10 6 10"
                        />
                        <path
                            className="ql-stroke"
                            d="M8.09,13.91A4.6,4.6,0,0,0,9,14,5,5,0,1,0,4,9"
                        />
                    </svg>
                </button>
                <button className="ql-redo">
                    <svg viewBox="0 0 18 18">
                        <polygon
                            className="ql-fill ql-stroke"
                            points="12 10 14 12 16 10 12 10"
                        />
                        <path
                            className="ql-stroke"
                            d="M9.91,13.91A4.6,4.6,0,0,1,9,14a5,5,0,1,1,5-5"
                        />
                    </svg>
                </button>
            </span>
        </ToolBar>
    );
};

export default CustomToolBar;

const ToolBar = styled.div`
    width: 100%;
    white-space: pre-wrap;
    line-height: 2 !important;
    padding: 6px 12px !important;
    margin-bottom: 12px;
    border: 1px solid ${theme.colors.ultraLightGrayBorder} !important;
    border-radius: 4px;

    & .ql-picker.ql-font {
        width: 136px !important;
    }
`;
